import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraCompareColumns } from '@mono/ui-components/captains';
import { SpecraQuote, SpecraText } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { companyLabel, comparisonRows } from './model';
/** The selected version as written, beside how it compares to the anchor. */ export function AgainstTheAnchor({ row }) {
    if (!row) {
        return /*#__PURE__*/ _jsx(SpecraText, {
            as: "p",
            size: "body-ui",
            tone: "muted",
            "data-testid": Testids.registryLcatAnchor.againstAnchor,
            children: "Select a version above to compare it against the anchor."
        });
    }
    return /*#__PURE__*/ _jsx(SpecraCompareColumns, {
        "data-testid": Testids.registryLcatAnchor.againstAnchor,
        framed: "panel",
        sides: [
            {
                id: 'as-written',
                eyebrow: `${companyLabel(row)} · as written`,
                title: row.titleAsWritten,
                body: row.description ? /*#__PURE__*/ _jsx(SpecraQuote, {
                    size: "body",
                    children: row.description
                }) : undefined,
                footer: `Source: ${row.source?.text || 'not recorded'}`
            },
            {
                id: 'anchor',
                eyebrow: 'Against the anchor',
                rows: comparisonRows(row),
                footer: row.reviewNote || undefined
            }
        ]
    });
}
